<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    v-if="visible"
    class="notice-edit"
    @cancel="onClose"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-form-model-item label="角色名称" prop="roleName">
        <InputText
          v-model="ruleForm.roleName"
          :disabled="modalType == '3'"
          allowClear
        />
      </a-form-model-item>

      <a-form-model-item label="角色级别" prop="roleLevel">
        <SelectModule
          v-model="ruleForm.roleLevel"
          apiType="getDictDataByCode"
          :apiParams="{ dictCode: 'role_level' }"
          isAllShow="请选择"
          :disabled="modalType == '3'"
        />
      </a-form-model-item>

      <a-form-model-item label="状态" prop="roleStatus">
        <SelectModule
          v-model="ruleForm.roleStatus"
          apiType="getDictDataByCode"
          :apiParams="{ dictCode: 'role_status' }"
          :showAll="true"
          :disabled="modalType == '3'"
        />
      </a-form-model-item>
      <a-form-model-item label="授权应用" prop="appShortName">
        <!-- <LenovoSelectModule
          :reset="true"
          placeholder="请输入"
          v-model="ruleForm.appShortName"
          apiType="getAllAppInfo"
          modelKey="appShortName"
          :paramsListObj="{ name: 'appShortName', id: 'id' }"
          modeType="multiple"
          @change="handleSelect"
          :selectData="selectData"
          :disabled="modalType == '3'"
        /> -->
        <LenovoSelectModule
          :reset="true"
          placeholder="请输入"
          v-model="ruleForm.appShortName"
          apiType="getAllAppInfo"
          modelKey="appShortName"
          modeType="multiple"
          @change="handleSelect"
          :selectData="selectData"
          :disabled="modalType == '3'"
          :backData="backData"
        />
      </a-form-model-item>
      <a-tabs @change="handleTab" v-model="activeKey">
        <a-tab-pane
          :tab="item.appShortName"
          v-for="(item, index) in selectData"
          :key="item.appId"
        >
          <div>
            <a-tree
              ref="tree"
              checkable
              v-model="item.roleMenuList"
              :tree-data="treeData"
              @check="onCheck"
              :expandedKeys.sync="defaultExpandedKeys"
              v-if="treeData.length"
              :disabled="modalType == '3'"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
    <template slot="footer">
      <a-button @click="onClose">{{
        modalType != "3" ? "取 消" : "关 闭"
      }}</a-button>
      <a-button type="primary" @click="onSave" v-if="modalType != '3'"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import LenovoSelectModule from "@/components/form/LenovoSelectMultiple"; // 联想下拉
import API from "@/api/sysManage.js"; // 请求接口
import SELECTAPI from "@/api/select.js";
import { nextTick } from "vue";
export default {
  components: {
    InputText,
    SelectModule,
    LenovoSelectModule,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
    // 操作项类型
    modalType: {
      type: String,
      required: true,
      default: "",
    },
  },
  computed: {
    title() {
      let str = "";
      if (this.modalType == "2") {
        str = "编辑";
      } else if (this.modalType == "1") {
        str = "新增";
      } else {
        str = "查看";
      }
      return str;
    },
  },
  created() {},
  data() {
    return {
      ruleForm: {
        id: "", // 主键ID
        roleName: "",
        roleStatus: "0",
        appShortName: [], // 授权应用
        roleLevel: ''
      },
      appManageInfoList: [], // 选择的授权应用以及树
      noticeOrgList: [],
      treeData: [], // 权限树数据
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称!", trigger: "change" },
        ],
        roleLevel: [
          { required: true, message: "请选择角色级别!", trigger: "change" },
        ],
        roleStatus: [
          { required: true, message: "请选择状态!", trigger: "change" },
        ],
        appShortName: [
          {
            required: true,
            type: "array",
            message: "请选择授权应用!",
            trigger: "change",
          },
        ],
      },
      funcAuthorities: [],
      visible: false,
      treeChildrenData: [], // 最深层子节点的合计
      isClick: false,
      checkArr: [],
      selectData: [], // 选中的授权数据
      activeKey: "", // 默认选中的tab
      defaultExpandedKeys: [], // 默认展开全部节点
      backData: [],
    };
  },
  methods: {
    // 选择授权应用
    handleSelect(data, option) {
      // 编辑
      if (this.selectData && this.selectData.length > 0) {
        // 新增
        if (option.length >= this.selectData.length) {
          let newNames = [];
          this.selectData.map((item) => {
            newNames.push(item.appShortName);
          });
          option.map((item) => {
            let obj = {};
            if (newNames.indexOf(item.name) == -1) {
              obj = {
                appId: item.id,
                appShortName: item.name,
                roleMenuList: [],
              };
              this.selectData.push(obj);
              this.appManageInfoList.push(JSON.parse(JSON.stringify(obj)));
            }
          });
        } else {
          // 删除
          let newNames = [];
          option.map((item) => {
            newNames.push(item.name);
          });
          this.selectData.map((val, index) => {
            if (newNames.indexOf(val.appShortName) == -1) {
              this.selectData.splice(index, 1);
            }
          });
          this.appManageInfoList.map((val, index) => {
            if (newNames.indexOf(val.appShortName) == -1) {
              this.appManageInfoList.splice(index, 1);
            }
          });
        }
      } else {
        let arr = [];
        option &&
          option.map((item) => {
            let obj = {
              appId: item.id,
              appShortName: item.name,
              roleMenuList: [],
            };
            arr.push(obj);
          });
        this.selectData = arr;
        this.appManageInfoList = JSON.parse(JSON.stringify(this.selectData));
      }
      // this.activeKey = option && option.length > 0 ? option[0].id : "";
      // this.handleTab(this.selectData[0].appId);
      if (this.selectData && this.selectData.length == 1) {
        this.handleTab(this.selectData[0].appId);
      }
      if (!this.selectData || this.selectData.length == 0) {
        this.treeData = [];
        this.funcAuthorities = [];
        this.treeChildrenData = [];
      }
      // this.appManageInfoList = JSON.parse(JSON.stringify(this.selectData));
    },
    // 选择tab
    handleTab(key, row) {
      this.activeKey = key;
      let initDefaultData = JSON.parse(JSON.stringify(this.selectData));
      initDefaultData &&
        initDefaultData.map((item) => {
          if (item.appId == key) {
            this.getMenuInit(item.appId, item.roleMenuList);
          }
        });
    },
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 菜单初始化
    getMenuInit(id, checked) {
      let params = {
        data: {
          params: {
            appId: id,
          },
        },
      };
      API.loadMenu(params, (callback) => {
        if (callback.status == "S" && callback.data) {
          if (Array.isArray(callback.data) && callback.data.length > 0) {
            let data = callback.data;
            this.treeData = this.getChildren(data);

            this.defaultExpandedKeys = this.getAllNode(data);

            if (checked && checked.length > 0) {
              this.noticeOrgList = [];
              let test = this.getFilter(callback.data); // 得到子元素
              let uniqueChild = this.uniqueTree(checked, test);
              this.funcAuthorities = uniqueChild;
              this.noticeOrgList = uniqueChild || [];

              setTimeout(() => {
                this.selectData.map((item) => {
                  if (item.appId == id) {
                    this.$set(item, "roleMenuList", this.noticeOrgList);
                  }
                });
              }, 500);
            }
          } else {
            this.treeData = [];
            this.defaultExpandedKeys = [];
            this.noticeOrgList = [];
            this.funcAuthorities = [];
          }
        }
      });
    },
    // 获取所有授权数据
    getData() {
      let paramsObj = {
        data: {
          params: {},
        },
      };
      SELECTAPI.getAllAppInfo(paramsObj, (callback) => {
        let list = [];
        if (callback.data.length > 0) {
          list = callback.data;
        }
        this.backData = list.map((item) => ({
          name: item.appShortName,
          id: item.id,
        }));
      });
    },
    // 获取角色详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
          },
        },
      };
      API.loadRoleById(params, (callback) => {
        let arr = [];
        let name = [];
        if (callback.status == "S" && callback.data) {
          let backData = callback.data;
          this.ruleForm.roleName = backData.roleName || "";
          this.ruleForm.roleStatus = backData.roleStatus || "0";
          this.ruleForm.roleLevel = backData.roleLevel || "";
          let roleMenus = backData.appManageInfoList || [];
          roleMenus &&
            roleMenus.map((item) => {
              arr.push({
                appId: item.appId,
                appShortName: item.appShortName,
                roleMenuList: item.roleMenuList || [],
              });
              name.push(item.appShortName);
            });
          this.ruleForm.appShortName = name;
          this.selectData = JSON.parse(JSON.stringify(arr));
          this.appManageInfoList = JSON.parse(JSON.stringify(arr));
          this.handleTab(arr[0].appId, arr[0].roleMenuList);
        }
      });
    },
    // 获取父节点
    getAllNode(data) {
      let itemArr = [];
      data &&
        data.map((item) => {
          itemArr.push(item.id);
          if (item.children) {
            this.getAllNode(item.children);
          }
        });
      return itemArr;
    },
    // 递归获取树形结构的子集
    getChildren(data) {
      let itemArr = [];
      data.forEach((item) => {
        let config = {
          title: item.label,
          key: item.id,
        };
        if (item.children) {
          config.children = this.getChildren(item.children);
        }
        itemArr.push(config);
      });

      return itemArr;
    },
    // 循环遍历出最深层子节点，存放在一个数组中
    getFilter(data) {
      // 关联
      data &&
        data.map((item) => {
          if (item.children && item.children.length > 0) {
            this.getFilter(item.children);
          } else {
            this.treeChildrenData.push(item.id);
          }
          return null;
        });
      return this.treeChildrenData;
    },
    uniqueTree(uniqueArr, Arr) {
      let uniqueChild = [];
      for (var i in Arr) {
        for (var k in uniqueArr) {
          if (uniqueArr[k] == Arr[i]) {
            uniqueChild.push(uniqueArr[k]);
          }
        }
      }
      return uniqueChild;
    },
    getCheckFilter(treeData, checkedKeys) {
      let config = {};
      if (treeData && treeData.length > 0) {
        treeData.map((item) => {
          if (checkedKeys.indexOf(item.key) != -1) {
            config = {
              orgId: item.key,
              orgName: item.title,
            };
            this.checkArr.push(config);
          }
          if (item.children && item.children.length > 0) {
            this.getCheckFilter(item.children, checkedKeys);
          }
        });
      }

      return this.checkArr;
    },
    // 选中某节点
    onCheck(checkedKeys, info, data) {
      // this.funcAuthorities = [];
      this.noticeOrgList = JSON.parse(JSON.stringify(checkedKeys)); // 当前选中节点
      this.funcAuthorities = [...checkedKeys, ...info.halfCheckedKeys]; // 包含父选中节点
      this.isClick = true;
      if (this.selectData && this.selectData.length > 0) {
        this.selectData.map((item) => {
          if (item.appId == this.activeKey) {
            item.roleMenuList = this.noticeOrgList;
          }
        });
      }

      if (this.appManageInfoList && this.appManageInfoList.length > 0) {
        this.appManageInfoList.map((item) => {
          if (item.appId == this.activeKey) {
            item.roleMenuList = this.funcAuthorities;
          }
        });
      }
      // this.$forceUpdate();
    },

    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      let params = {
        data: {
          params: {
            id: this.modalData.id || "",
            roleName: this.ruleForm.roleName,
            roleStatus: this.ruleForm.roleStatus,
            appManageInfoList: this.appManageInfoList,
            roleLevel: this.ruleForm.roleLevel,
            // appManageInfoList: this.selectData,
          },
        },
      };
      API.mergeRole(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (this.modalType == "2") {
            str = "编辑";
          } else if (this.modalType == "1") {
            str = "新增";
          }
          this.$message.destroy();
          this.$message.success(`${str}成功`);
          this.$emit("handleFlag", false, {}, this.modalType, "ok");
        }
      });
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        this.getData();
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        } else {
          this.$nextTick(() => {
            this.ruleForm.roleStatus = "0";
          });
        }
      } else {
        this.isClick = false;
        this.treeData = [];
        this.funcAuthorities = [];
        this.treeChildrenData = [];
        this.selectData = [];
        this.ruleForm.id = "";
        this.ruleForm = {
          id: "", // 主键ID
          roleName: "",
          roleStatus: "",
          appShortName: [], // 授权应用
          roleLevel: ""
        };

        this.backData = [];
        this.noticeOrgList = [];
        this.appManageInfoList = [];
        this.$refs.ruleForm.resetFields();
      }
    },
  },
};
</script>

<style scoped lang="less">
.notice-edit {
  .tree {
    margin-bottom: 0;
    .ant-form-item-control {
      height: auto;
    }
  }
}
</style>
